import React from 'react';
export const RightIcon = ({ fillColor = '#FFF' }) => (
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.1997 10.4899L13.2297 8.51993L10.0197 5.30993C9.33969 4.63993 8.17969 5.11993 8.17969 6.07993V12.3099V17.9199C8.17969 18.8799 9.33969 19.3599 10.0197 18.6799L15.1997 13.4999C16.0297 12.6799 16.0297 11.3199 15.1997 10.4899Z" fill={fillColor}/>
</svg>);
